/**
 * Beschriftungen der Kundenportal-Bereiche und -Rollen.
 *
 * Eine Quelle für Admin-Dialoge und Portal-Sicht — steht dieselbe Sache in zwei
 * Oberflächen unterschiedlich beschriftet, sucht am Telefon jeder das Falsche.
 * Register der Bereiche: backend/src/constants/portalModules.ts
 */
export const PORTAL_MODULE_LABELS: Record<string, string> = {
  tickets: 'Tickets',
  requests: 'Anfragen',
  inbox: 'Postfach',
  shop: 'Shop',
  quotes: 'Angebote',
  submissions: 'Serviceberichte',
  reports: 'Unsere IT',
  assets: 'Assets & Geräte',
  contracts: 'Verträge & Lizenzen',
  appointments: 'Termine',
  projects: 'Projekte',
  trust: 'Trust Center',
  audit: 'Protokoll',
  dns: 'DNS-Zonen',
};

export const PORTAL_ROLE_LABELS: Record<string, string> = {
  ADMIN: 'Administrator',
  MITARBEITER: 'Mitarbeiter',
  GAST: 'Gast',
};
